import * as React from 'react';
import { Glyphicon, Popover, OverlayTrigger } from 'react-bootstrap';
import { MultiText } from 'fw/forms';

class MultiEmailBox extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            emails: (props.value && props.value.split(";")) || []
        }
    }

    // Public
    setValue = (value) => {
        this.setState({ emails: value.split(";") });
    }

    getValue = () => {
        return this.state.emails.join(";");
    }

    focus = () => {
        this._input.focus();
    }

    flag = (status) => {
        this._input.flag(status);
	}

	completed = (e) => {
        const emails = e || this.state.emails;

		return !((emails === null || !emails.join || emails.join(";") === "") && this.props.required)
	}

    validate = () => {
        return null;
    }

    _validateEmail(email) {
        var re = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        return re.test(String(email).toLowerCase());
    }

    _handleOnChange = emails => {
        this._update(emails);

        this.props.onDirt && this.props.onDirt();
    }

    _handleInputFocus = (e) => {
        this.props.onFocus && this.props.onFocus();
    }

    _handleInputBlur = (e) => {
        this.props.onBlur && this.props.onBlur();
	}

    _update = (emails) => {
		this.setState({ emails: emails }, () => {
			const validationResult = this.validate();
			const requiredPassed = this.completed(emails);
			const validationPassed = (validationResult === null || validationResult === undefined);
			const status = requiredPassed && validationPassed;

            // Show error status if neccesary
			this.flag(status);

			// Trigger standard onChange...
			this.props.onChange && this.props.onChange(emails.join(";"));
			this.props.managed && this.props.onFieldChange(emails.join(";"), this.props.name);
		});
	}

    componentDidMount() {
        if (this.props.autoFocus)
            this.focus();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.emails.join(";") !== nextProps.value)
            this.setState({
                emails: (nextProps.value && nextProps.value.split(";")) || []
            });
    }

    // React
    render() {
        const popover = (
            <Popover id="popover-basic">
                You can enter more than one email, separating them using the ; character.
            </Popover>
        );

        // GetLabel is the method to render every email string
        const props = {
            value: this.state.emails,
            name: this.props.name,
            placeholder: this.props.placeholder,
            onChange: this._handleOnChange,
            filter: this._validateEmail,
            required: this.props.required,
            disabled: this.props.disabled,
            onFocus: this._handleInputFocus,
            onBlur: this._handleInputBlur,
            separator: ";",
            maxLength: this.props.maxLength
        }

        return (
            <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                <div className="input-group">
                    <MultiText className="form-control" {...props} ref={input => this._input = input} />
                    <div className="input-group-addon">
                        <Glyphicon glyph="envelope" />
                    </div>
                </div>
            </OverlayTrigger>
        );
    }
}

export default MultiEmailBox;

// Mark this as a form component
MultiEmailBox.defaultProps = {
    formControl: true,
    managed: false,
    maxLength: 64
};



// WEBPACK FOOTER //
// ./src/fw/forms/controls/multiEmailBox/MultiEmailBox.js